export default __webpack_public_path__ + "static/media/coinbaseWallet.7a7d6edc.png";